const english = {
  404: {
    title: "Oops, something went wrong",
    text: "The page you are looking for does not exist.",
  },
  addEmployees: {
    title: "Add employees",
    step: "Step {{step}} of {{total}}",
    next: "Continue",
    back: "Back",
    submitting: "Submitting...",
    step1: {
      title: "Select employees",
      existingEmployees: "Existing employees",
      employeeCount: "Showing {{count}} of {{total}}",
      searchLabel: "Search existing employees",
      searchPlaceholder: "Search by name or email…",
      noExistingEmployees: "No existing employees found",
      noSearchResults: "No matching employees found",
      newEmployees: "New employees",
      added: "added",
      new: "New",
      addNewEmployee: "Add new employee",
      addButton: "Add",
      removeEmployee: "Remove {{email}}",
    },
    step2: {
      title: "Select educations",
      defaultOffers: "Default for all",
      defaultOffersHelp:
        "Choose which educations should apply to all employees by default.",
      employeeOffers: "Employees",
      applyDefaultToAll: "Apply default to all",
      change: "Change",
      editOffersFor: "Edit educations for",
      noOffersSelected: "No educations selected",
      recommendedOffer: "Recommended based on your company",
    },
    step3: {
      title: "Summary",
      employeeSummary: "Employees and educations",
      employee: "Employee",
      offers: "Educations",
      price: "Price",
      subtotal: "Subtotal",
      volumeDiscount: "Volume discount",
      employees: "employees",
      volumeDiscountInfo: "Order {{threshold}} or more to get 10% discount!",
      total: "Total",
      notesLabel: "Notes (optional)",
      notesPlaceholder: "Write any notes here...",
      infoText:
        "When you confirm the order, new users will be created immediately and receive a welcome email. You will be invoiced afterwards.",
      confirmOrder: "Confirm order",
    },
    selectEducations: {
      title: "Select educations",
      employees: "Employees",
      newEducationsCount: "{{count}} new educations selected",
      new: "new",
      alreadyOwned: "Already purchased",
      purchased: "(Purchased)",
    },
    summary: {
      title: "Summary",
      newEducations: "new educations",
      employeesAffected: "employees",
      orderDetails: "Order details",
      newEducationsColumn: "New educations",
      educations: "educations",
      volumeDiscountInfo:
        "Order {{threshold}} or more educations to get 10% discount!",
    },
    form: {
      firstname: "First name",
      firstnamePlaceholder: "Enter first name",
      lastname: "Last name",
      lastnamePlaceholder: "Enter last name",
      email: "Email",
      emailPlaceholder: "Enter email address",
    },
    validation: {
      emailRequired: "Email is required",
      emailInvalid: "Invalid email address",
      emailExists: "This email address already exists in the system",
      firstnameRequired: "First name is required",
      lastnameRequired: "Last name is required",
    },
    errors: {
      loadOffersFailed: "Could not load educations. Please try again.",
      createOrderFailed: "Could not create the order. Please try again.",
    },
    success: {
      orderCreated: "Order has been created!",
    },
  },
  orderHistory: {
    title: "Order History",
    noOrders: "No orders found",
    status: {
      pending: "Pending approval",
      approved: "Approved",
      rejected: "Rejected",
    },
    columns: {
      date: "Date",
      employees: "Employees",
      total: "Total",
      status: "Status",
      invoice: "Invoice",
    },
    errors: {
      loadFailed: "Could not load order history",
    },
  },
  userErrors: {
    serverError: "Server error - please try again later",
    loginRequired: "You need to log in again",
    permissionDenied: "You do not have permission to access this information",
    serviceUnavailable: "The service is temporarily unavailable - please try again later",
    checkConnection: "Check your internet connection and try again",
    unexpectedError: "An unexpected error occurred - please try again later",
  },
  account: {
    title: "Account",
    subtitle: "Manage your details.",
    emailChangePrompt: "Want to change your email address? Email us at",
    emailChangeAddress: "info@finanslicenser.se",
    logout: "Log out",
    firstname: "First name",
    surname: "Surname",
    email: "Email",
    company: "Company",
    language: "Language",
    languageSwedish: "Swedish",
    languageEnglish: "English",
    edit: "Edit name",
    save: "Save",
    cancel: "Cancel",
    profileUpdated: "Profile updated successfully",
    updateError: "Failed to update profile",
    nameRequired: "At least one name must be provided",
    firstnamePlaceholder: "Enter first name",
    surnamePlaceholder: "Enter surname",
    notProvided: "—",
  },
  ai: {
    greetingMessage:
      "Hi! I am an AI and my task is to ask you a few control questions to make it easier for you to remember and understand the content. I don't know everything and I'm not an all-knowing expert, but I'm here to remind you, explain things simply, and make your learning a bit more interactive. Think of it as a short training session before it's time for the real tests!",
    welcomeBackMessage: "Welcome back",
    introMessage:
      "Hi! I will now ask some control questions to" +
      " see that you have understood the text.",
    error: "Something went wrong during startup.",
    pasteNotAllowed: "Copy and paste is not allowed.",
    somethingWrong: "Something went wrong. Please try again.",
    inputPlaceholder: "Enter your answer here...",
    send: "Send",
    modalTitle: "Finanslicenser AI",
    switchToQuestions:
      "Does AI Chat not feel right for you? Switch to traditional questions",
    switchToAIChat: "Want to try a new way to practice? Try our AI questions!",
    retry: "Try again",
    offlineWarning: "You are offline. Connect to the internet to continue.",
    errors: {
      offline:
        "You appear to be offline. Check your internet connection and try again.",
      network:
        "Could not connect to the server. Check your internet connection and try again.",
      serviceUnavailable:
        "The AI service is temporarily unavailable. Please try again in a moment.",
      emptyResponse:
        "Received no response from the AI. Try again or switch to traditional questions.",
    },
    feedback: {
      title: "What did you think of the chat?",
      thumbsDown: "Bad",
      thumbsUp: "Good",
      placeholder: "Share your thoughts about the chat (optional)...",
      submit: "Submit feedback",
      thankYou: "Thank you for your feedback!",
      error: "An error occurred when submitting feedback.",
    },
    theoryChatButton: "Questions about the text?",
    theoryChatTitle: "Ask AI about the theory",
    theoryChatGreeting:
      "Hi! I'm an AI bot and I can answer questions about the theory. What would you like to know?",
    theoryChatInputPlaceholder: "Ask a question...",
    accuracyWarning:
      "AI may be incorrect. Always verify important information.",
    directQuestionPlaceholder:
      "Ask our AI if you have any questions about the text",
    selectionSimplify: "Explain in simpler terms",
    selectionExplain: "Explain more",
    selectionExample: "Give example",
    selectionChat: "Ask AI",
    selectionSimplifyPrompt:
      'Can you simplify and explain the following text in a simple way?\n\n"{{text}}"',
    selectionExplainPrompt: 'Explain what "{{text}}" means.',
    selectionExamplePrompt:
      'Can you give a concrete, real-world example that illustrates the following?\n\n"{{text}}"',
    selectedTextLabel: "Selected text",
    textSelectionTip:
      "💡 Tip: Select text in the theory to get quick options to ask about",
  },
  aiChatChoice: {
    title: "Choose Learning Format",
    description:
      "You can choose between two different ways to practice this chapter:",
    questionCount: "This chapter has {{count}} questions available",
    saveChoice: "Save my choice",
    aiChat: {
      title: "AI Chat",
      description:
        "Interactive conversation with AI that asks personalized questions based on the content. Perfect for deepening understanding and getting personal feedback.",
      button: "Choose AI Chat",
    },
    questions: {
      title: "Traditional Questions",
      description:
        "Classic multiple-choice questions that systematically test your knowledge. Great for exam preparation and ensuring basic understanding.",
      button: "Choose Questions",
    },
  },
  admin: {
    table: {
      allCourses: "All courses",
      addUser: "Add user",
      addCourse: "Add course",
      title: "Administration",
      subtitle:
        "Overview of employees, courses, and certificates. " +
        "Download individual certificates or a summary per course.",
      contactPrompt:
        "Want to add users or courses? Email us at <email>info@finanslicenser.se</email> or call <phone>076-345 00 87</phone>.",
      description:
        "As an administrator, you have access here to a comprehensive " +
        "overview of all employees and their training status. " +
        "You can download individual" +
        " certificates or generate a summary per course.",
      completed: "Completed",
      coursesFilter: "Show courses",
      downloadSelected: "Download selected",
      downloadMultiple: "Download summary certificate",
      pickCourse: "All courses",
      searchLabel: "Search employees",
      searchPlaceholder: "Name or email",
      coursesCompletedSummary: "{{completed}} of {{total}} courses completed",
      coursesCount: "{{count}} courses",
      expandEmployee: "Show courses, {{name}}",
      collapseEmployee: "Hide courses, {{name}}",
      employeeCoursesRegion: "Courses for {{name}}",
      noResultsTitle: "No matches",
      noResultsText: "Adjust the course filter and try again.",
      columns: {
        name: "Name",
        employee: "Employee",
        email: "Email",
        course: "Course",
        levels: "Completed levels",
        lastActivity: "Last active",
        lastCompleted: "Completed",
        educations: "Courses",
        certificate: "Certificate",
        download: "Download",
      },
      mailTemplate: {
        subject: "Add user",
        body: `Hi!

I would like to add one or more users to this course.

Here is the information:

1. 
First name: 
Surname: 
Email: 
Course:

2. 
First name: 
Surname: 
Email: 
Course:

Please confirm when the users have been added to the system.

Best regards,`,
      },
      mailTemplateCourse: {
        subject: "Add course",
        body:
          "Hi!\nI would like to add this course (GDPR, " +
          "Cybersecurity, Anti-Money Laundering, Sales & Marketing, " +
          "Anti-corruption) for me and my employees.\nPlease confirm " +
          "when we have been added to the course.",
      },
      selected: "selected",
      noData: "No courses available",
    },
  },
  certificates: {
    detailsSection: "Certificate details",
    actionsSection: "Actions",
    aboutTitle: "About the education",
    metaIssuer: "Issuer",
    metaIssued: "Issued",
    metaValidUntil: "Valid until",
    titleSingle: "Download your certificate",
    titleMultiple: "Download your certificates",
    errorDownload: "Could not download the certificate.",
    errorOpenCert:
      "Could not open the certificate in a new tab. You must " +
      "allow popups in your browser.",
    noAvailable: "No certificates available.",
    downloadFilename: "Education summary.pdf",
    errorFetch: "Could not fetch the certificate.",
    educationFallback: "Education",
    verified: "Verified",
    linkedinCertName: "Certified education - {{education}}",
    addToLinkedIn: "Share on LinkedIn",
    downloadDescription:
      "To comply with rules and requirements, you should download your certificate and save it in a secure place.",
    downloadButton: "Download certificate",
    downloadButtonShort: "Download",
    loadingCertificate: "Loading certificate...",
    loadingCourse: "Loading course...",
    validUntil: "Valid until:",
    expiredBadge: "Expired",
    expiredInfo:
      "This certificate has expired. Complete a new annual update to refresh your documentation.",
  },
  courseCompleted: {
    congratulationsTitle: "Congratulations on completing the course!",
    congratulationsMessage: "You have successfully completed the course.",
    expiredTitle:
      "This course is finished and no longer available.",
    expiredMessage:
      "This course has ended and can no longer be completed or certified. AML regulations require ongoing training, and certificates for annual updates are valid for 12 months from completion. Contact us if you need to complete a new annual update.",
    expiredDiscountOfferBefore:
      "We understand that this can feel frustrating, and we want to help you move forward. Contact us at ",
    expiredDiscountOfferAfter:
      " and we'll arrange 50% off on AML 2026 for you.",
    error:
      "An error occurred when fetching the certificates." +
      " Please try again later.",
    noCertificateAvailable:
      "This certificate is not available for this course.",
    loading: "Loading certificate. Please wait...",
    showCertificate: "Show certificate",
    popup: {
      badge: "Course completed",
      title: "Congratulations on completing the course!",
      subtitle:
        "You have successfully passed all steps and completed the course!",
    },
  },
  confirmationPopup: {
    stay: "No, stay",
  },
  components: {
    breadcrumbs: "Breadcrumbs",
    pages: "Pages",
    previousPage: "Previous page",
    nextPage: "Next page",
    notices: "Notices",
    previousNotice: "Previous notice",
    nextNotice: "Next notice",
    closeNotices: "Close notices",
  },
  education: {
    notAvailable: {
      title: "Read more about this course and book directly on the website.",
    },
  },
  educationContent: {
    loadingSteps: "Loading course steps",
    levelsLoadError:
      "Could not load the steps. Please check your internet connection and try again.",
    courseDataLoadError:
      "Could not load the course. Please check your internet connection and try again.",
    multipleChoice: {
      noAvailable: "No questions available",
    },
    fillInBlank: {
      noData: "No fill-in-blank data available",
      wordBankLabel: "Drag/tap the correct words to the empty fields:",
      allWordsPlaced: "All words have been placed",
      blankFilled: "Field filled with: {{word}}",
      blankEmpty: "Empty field, click to place a word",
    },
    confirationPopup: {
      badge: "Locked",
      title: "Step locked",
      message:
        "You cannot skip ahead. Follow the order to ensure" +
        " you do not miss important information.",
      messageDiagnostic: "You can only take a diagnostic test once.",
    },
    quiz: {
      title: "Quiz",
    },
  },
  feedbackView: {
    title: "Thank you very much",
    subtitle: "What did you think of the course?",
    headerTitle:
      "If you have the opportunity, please continue to rate " +
      "your experience.",
    questionTitle: "Do you have any other comments?",
    save: "Send",
    saving: "Sending...",
    skip: "Skip",
    thankYouBody: "Your feedback helps us improve our courses.",
    sentiment: {
      veryBad: "Very bad",
      bad: "Bad",
      neutral: "Okay",
      good: "Good",
      veryGood: "Very good",
    },
    modal: {
      noAuth: "User is not authenticated. Please log in and try again.",
      questions: {
        recommend: "Would you recommend the course to a colleague?",
        easyToUse: "How easy was it to use the training platform?",
        materialQuality: "How do you rate the quality of the content?",
        aiChatQuality: "How did you like the interactive AI chat?",
        roleplayQuality: "How did you like the roleplay exercises?",
      },
      questionFeedback:
        "Please tell us more about why you didn't like {{question}} (Optional)",
      questionFeedbackPlaceholder: "Write your feedback here...",
      questionShortDescriptions: {
        recommend: "the recommendation",
        easyToUse: "the platform",
        materialQuality: "the content",
        aiChatQuality: "the AI chat",
        roleplayQuality: "the roleplay exercises",
        overall: "the course",
      },
    },
  },
  header: {
    progress: "{{progress}}% completed",
    fortnoxPartnershipLogoAlt: "In collaboration with Fortnox",
  },
  educationSnake: {
    pageSubtitle: "Work through the steps at your own pace.",
  },
  educationOverview: {
    stepsCompleted: "{{completed}} of {{total}} steps completed",
    ofTotal: "of {{total}}",
    start: "Start the training",
    continue: "Continue",
    nextStep: "Next: {{label}}",
  },
  reviewPopup: {
    title: "Congratulations on completing the course!",
    badge: "Course completed",
    subtitle:
      "You have successfully passed all steps and completed the course!",
  },
  levels: {
    startHere: "Start here",
    youAreHere: "You are here",
    examShort: "Exam",
    quizShort: "Quiz",
    section: "Section {{number}}",
    sectionDone: "{{count}} of {{count}} done",
    sectionInProgress: "In progress · {{completed}} of {{total}}",
    sectionUpcoming: "{{count}} steps",
    certificateGoal: {
      title: "Certificate",
      locked: "You receive your certificate when you pass the final test.",
      open: "Open your certificate",
      unlocked: "Done! Open your certificate.",
    },
    theory: {
      title: "",
      faq: {
        title: "FAQ",
        subtitle: "Answers to common questions about this chapter",
        showAll: "Show all questions",
        showLess: "Show less",
        questionsCount: "{{count}} questions",
      },
      tts: {
        listen: "Listen",
        play: "Play",
        playing: "Playing...",
        paused: "Paused",
        loading: "Loading audio...",
        error: "Could not play",
        stop: "Stop",
        progress: "Playback position",
      },
    },
    missing: "The level is missing or could not be loaded.",
    header: {
      badge: "Leave step",
      title: "Do you want to leave the step?",
      subtitle: "Your progress will be lost for this step!",
    },
    readMore: "Read the full text",
    video: {
      title: "Video",
      loadingPoster: "Loading preview",
    },
    completeLevel: "Complete level",
    questions: {
      explanationBox: "Explanation",
    },
    quiz: {
      title: "Quiz",
      description:
        "You'll find out right after each question whether you answered correctly.",
      start: "Start the quiz",
      startTest: "Start the test",
      loadingLevels: {
        text: "Loading levels",
      },
    },
    startScreen: {
      factsLabel: "About the test",
      questions: "Questions",
      passRequirement: "Pass mark",
      passRequirementValue: "{{percentage}}% correct",
    },
  },
  questions: {
    answers: {
      yes: "Yes",
      no: "No",
      true: "True",
      false: "False",
    },
  },
  report: {
    title: "Feedback",
    titleQuestion: "What is your feedback about?",
    subtitleSelect: "What is your feedback about?",
    button: "Feedback",
    categories: {
      spelling: "Spelling",
      factual: "Factual error",
      feedback: "Improvement suggestion",
      other: "Other",
    },
    commentsLabel: "Tell us more (Optional)",
    send: "Send",
    toastSuccess: "Thanks! Your feedback was sent.",
    errors: {
      notAuthenticated: "You must be logged in to report.",
      generic: "Could not send the report. Please try again later.",
      tooLong: "Text can be max 5000 characters.",
      missingCategory: "Please select a category.",
    },
  },
  menu: {
    progressPercent: "{{progress}} %",
    progressAria: "{{progress}}% complete",
    progressCompleted: "Completed",
    close: "Close menu",
    collapseSidebar: "Collapse sidebar",
    expandSidebar: "Expand sidebar",
    account: "Account",
    admin: "Administration",
    adminLink: "Admin",
    adminTitle: "Admin",
    buttonTitle: "Menu",
    brandLogoAlt: "Finanslicenser",
    certificate: "Certificate",
    myCertificates: "My certificates",
    myEducations: "My courses",
    educations: "Courses",
    expiredEducations: "Expired courses",
    noActiveEducations: "No active courses.",
    loadingEducations: "Loading courses",
    followOnLinkedIn: "Follow Finanslicenser on LinkedIn for news and offers",
    followOnLinkedInShort: "Follow us on LinkedIn",
  },
  certificatesPage: {
    title: "My certificates",
    description:
      "All the certificates you have earned, collected in one place. Click a" +
      " certificate to view or download it.",
    emptyTitle: "No certificates yet",
    emptyDescription:
      "When you complete a course, the certificate will appear here.",
    untitled: "Certificate",
    completed: "Issued",
    valid: "Valid",
    expired: "Expired",
    dateUnknown: "Date unavailable",
    loadError: "Could not load your certificates. Please try again.",
    thumbnailError: "Could not display",
    openCertificate: "Open certificate for {{title}}",
    nextTitle: "Find your next course",
    nextDescription:
      "We scanned Finanslicenser.se and highlighted courses that help you" +
      " level up. Keep collecting certificates and strengthen your profile.",
    nextCta: "View course →",
    catalogNote:
      "Want the full catalog? Visit <link>Finanslicenser.se</link> for the latest offerings.",
    catalogCta: "Go to Finanslicenser.se",
    recommendations: {
      penningtvatt: {
        title: "Anti-Money Laundering",
        description:
          "Tailored for accounting consultants, payment service providers, and more.",
        tag: "Compliance",
      },
      gdpr: {
        title: "GDPR",
        description:
          "Focus on handling personal data and data protection.",
        tag: "Data Protection",
      },
      antikorruption: {
        title: "Anti-corruption",
        description:
          "Learn to identify and prevent corruption in your organization.",
        tag: "Compliance",
      },
      tolvregeln: {
        title: "3:12 Rule",
        description:
          "Tailored for accounting consultants working with closely held companies.",
        tag: "Tax",
      },
      cybersakerhet: {
        title: "Cybersecurity",
        description:
          "Concrete measures to protect your business.",
        tag: "Security",
      },
    },
  },
  levelCompleted: {
    title: "Step completed!",
    message: "You are now ready to continue",
  },
  login: {
    error: "Could not log in. Please try again.",
    mobileMessage:
      "For the best experience, please use a computer to log in and" +
      " complete the course.",
    mobileCTA: "Download the app",
    logoTitle: "Courses in banking and finance.",
    button: "Log in",
    email: "Email",
    password: "Password",
    passwordPrompt: "At least 6 characters",
    forgotPassword: "Forgot your password?",
    clickHere: "Click here",
    enterEmail: "Enter your email address above to reset your password.",
    resetEmailSent: "If the email exists, a reset link has been sent.",
    resetCheckSpamBefore: "Check your ",
    resetCheckSpamBold: "spam",
    resetCheckSpamAfter: " folder if the email doesn't arrive",
    resetError: "Could not send reset email. Check the address and try again.",
    resetButton: "Reset password",
    backToLogin: "Back to login",
    emailTemplate: {
      forgotPasswordSubject: "Password reset request",
      forgotPasswordBody:
        "Hi,\n\nI need help " +
        "resetting my password.\nCould you please send me a new " +
        "password?",
    },
  },
  quizSuccessPopup: {
    title: "Passed",
    badge: "Passed",
    scoreUnit: "%",
    correctCount: "{{totalCorrectAnswers}} of {{totalAnswers}} questions correct",
    progressLabel: "{{percentageCorrect}} percent correct",
    message: "Congratulations, you passed the quiz.",
    submessage: "({{totalCorrectAnswers}} / {{totalAnswers}} questions)",
  },
  diagnosticTest: {
    title: "Diagnostic test",
    bottomText:
      "This is a diagnostic test. Topics you already master " +
      "will be excluded from your training, while areas you need" +
      " to improve will be repeated in upcoming lessons.",
    start: "Start test",
    loadingLevels: {
      text: "Customizing levels for you",
    },
  },
  diagnosticTestPopup: {
    title: "Test completed",
    badge: "Test completed",
    correctCount: "{{totalCorrectAnswers}} of {{totalAnswers}} questions correct",
    message: "Diagnostic test completed.",
    body:
      "Based on your results, we can now tailor a training plan" +
      " that matches your knowledge level.",
    submessage:
      "({{totalCorrectAnswers}} / {{totalAnswers}} questions) correct",
    areasToImprove: "Areas to repeat",
    masteredAreas:
      "Competence confirmed (You do not need to repeat these areas)",
    error: "An error occurred",
    unknownArea: "Unknown area",
  },
  tabbar: {
    stepByStep: "Step by step",
    theory: "Theory",
    exercise: "Practice",
    certificate: "Certificate",
    documents: "Documents",
  },
  documents: {
    subtitle: "Download course materials and documents",
    download: "Download",
    empty: "No documents available",
  },
  theoryList: {
    title: "Theory",
    subtitle: "Read all chapters at your own pace.",
    other: "Other",
    itemFallback: "Theory",
    lockedTitle: "This view is locked",
    lockedMessage:
      "Complete all steps in the 'Step by step' tab to unlock the theory sections.",
    lockedPopupTitle: "Content is locked",
    lockedPopupMessage:
      "You must complete all steps in the 'Step by step' tab before you can read this theory section.",
    lockedPopupButton: "I understand",
  },
  practice: {
    emptyCategories: "No categories found.",
    ctaMany: "Practice {{count}} categories",
    ctaAll: "Practice everything",
    examTitle: "Practice Exam",
    examDescription: "Here you can take practice exams. (Coming soon)",
  },
  quizFailedPopup: {
    title: "Failed",
    badge: "Failed",
    correctCount: "{{totalCorrectAnswers}} of {{totalAnswers}} questions correct",
    message:
      "You got {{percentageCorrect}}% correct. You can retake" +
      " the test at any time until you reach at least 70%.",
    submessage: "({{totalCorrectAnswers}}/{{totalAnswers}} questions)",
  },
  roleplay: {
    title: "Role play",
    defaultSceneDescription: "📩 Answer the task below.",
    placeholder: "Type your answer...",
    loadingResponding: "Responding...",
    loadingEvaluating: "Evaluating...",
    send: "Send",
    analyzeAnswer: "Analyze answer",
    analysis: "Analysis",
    explanation: "Explanation",
    analyzing: "Analyzing...",
    analysisComplete: "Analysis complete. Your score: {{score}}%",
    goodExampleTitle: "Example of a good answer",
    retry: "Try again",
    yourAnswer: "Your answer",
    fetching: "Fetching...",
    stepCompletedAnalyzing: "Steps completed. Analysis in progress below.",
    previousSteps: "Previous steps",
    conversationEnded: "Conversation ended.",
    assistantInitial: "A",
    userInitial: "Y",
    imageAlt: "roleplay",
    imageLoadError: "Could not load image",
    feedback: {
      title: "How was the roleplay training?",
      thumbsDown: "Bad",
      thumbsUp: "Good",
      placeholder:
        "Share your thoughts about the roleplay training (optional)...",
      submit: "Submit feedback",
      thankYou: "Thank you for your feedback!",
      error: "An error occurred while submitting feedback.",
    },
    errors: {
      generic: "Something went wrong. Please try again later.",
      simulationFetch: "Could not fetch response from simulation.",
      stepGeneric: "Something went wrong. Please try again.",
      evaluationFailed: "Evaluation failed",
      parseFailed: "Could not parse evaluation",
    },
  },
  branchingStory: {
    title: "Interactive story",
    notFound: "The story could not be found.",
    noNodes: "The story is missing content.",
    start: "Begin investigation",
    storyEnd: "End",
    endingGood: "Excellent!",
    endingAcceptable: "Well done!",
    endingBad: "Unsuccessful ending",
    completed: "Completed",
    yourChoices: "Your choices",
    tryAgain: "Try again",
    whatWentWrong: "What went wrong?",
    levelCompleted: "Level completed",
    allQuestionsAnswered: "You have answered all questions correctly!",
  },
  common: {
    continue: "Continue",
    completed: "completed",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    error: "Something went wrong",
    errorOccurred: "An error occurred",
    errorTryAgain: "Something went wrong, please try again later.",
    tryAgain: "Try again",
    loading: "Loading...",
    quit: "Quit",
    readMore: "Read more",
    readInDepth: "Read in-depth",
    closeInDepth: "Close in-depth",
    done: "Done",
  },
  welcome: {
    title: "Welcome to Finanslicenser",
    subtitle: "Click the menu to choose a course",
    arrowText: "Choose course here.",
    noCourses: "You have no active courses at the moment.",
  },
  error: {
    title: "Something went wrong",
    generic: "An unexpected error occurred. Please try again.",
    retry: "Try again",
    coursesLoadFailed:
      "Could not load courses. Check your internet connection and try again.",
    userCoursesLoadFailed:
      "Could not load your courses. Please try again later.",
  },
  referralLanding: {
    hero: {
      title: "{{name}} ({{company}}) has invited you",
      subtitle: "You get {{discount}}% discount the first year!",
      discountBadge: "{{discount}}% discount the first year",
      rating: "{{rating}} out of 5",
    },
    packages: {
      title: "Choose your package",
      originalPrice: "Regular price {{price}}",
      recommended: "Most popular",
      perPersonYear: "per person / year",
      save: "Save {{amount}}",
      readMore: "Read more",
    },
    form: {
      title: "Register your company",
      contactPerson: "Contact person",
      contactPersonPlaceholder: "Enter contact person name",
      orgNumber: "Organization number",
      orgNumberPlaceholder: "Enter organization number",
      email: "Email",
      emailPlaceholder: "Enter email address",
      participantCount: "Number of participants",
      participantCountPlaceholder: "Enter number of participants",
      acceptTerms: "I accept the terms and conditions",
      submit: "Submit registration",
      submitting: "Submitting...",
    },
    errors: {
      contactPersonRequired: "Contact person is required",
      orgNumberRequired: "Organization number is required",
      orgNumberInvalid: "Invalid organization number (must be 10 or 12 digits)",
      emailRequired: "Email is required",
      emailInvalid: "Invalid email address",
      participantCountRequired: "Number of participants is required",
      participantCountInvalid: "Number of participants must be at least 1",
      packageRequired: "Please select a package",
      termsRequired: "You must accept the terms and conditions",
    },
    success: {
      message:
        "Thank you! Your registration has been submitted. We will contact you soon.",
    },
  },
};

export default english;
